<template>
    <material-item class="my-file-item" :material="material">
        <div slot="footer">
            <span class="file-stat"><svg-icon :symbol="likeIcon" :original-dims="true" class="icon-inline"></svg-icon><span class="count">{{ material.likes }}</span></span>
            <span class="file-stat"><svg-icon :symbol="viewIcon" :original-dims="true" class="icon-inline"></svg-icon><span class="count">{{ material.views }}</span></span>
            <span class="file-stat"><svg-icon :symbol="downloadIcon" :original-dims="true" class="icon-inline"></svg-icon><span class="count">{{ material.downloads }}</span></span>
        </div>
    </material-item>

</template>

<script>
    import SvgIcon from './SvgIcon.vue';
    import MaterialItem from './MaterialItem';

    import likeIcon from '../../icons/icon-like.svg-sprite';
    import viewIcon from '../../icons/icon-view.svg-sprite';
    import downloadIcon from '../../icons/icon-download.svg-sprite';

    export default {
        props: ['material'],

        data: function () {
            return {
                likeIcon,
                viewIcon,
                downloadIcon
            }
        },

        components: { SvgIcon, MaterialItem }
    }
</script>

<style lang="scss">
    .my-file-item {
        > footer > div {
            justify-content: flex-start;

            .file-stat {
                margin-right: 1em;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/MyMaterialItem.vue